import { render } from "./RechargeModal.vue?vue&type=template&id=1465dd77&scoped=true"
import script from "./RechargeModal.vue?vue&type=script&lang=js"
export * from "./RechargeModal.vue?vue&type=script&lang=js"

import "./RechargeModal.vue?vue&type=style&index=0&id=1465dd77&lang=scss&scoped=true"

import exportComponent from "D:\\由创科技-ljx\\apicode\\github\\DY.Web\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1465dd77"]])

export default __exports__